export default __webpack_public_path__ + "assets/images/image_business.51eebfd7.png";